<template>
  <picker-field
    :label="label"
    :display="display"
    :title="title"
    ref="picker"
  >
    <div class="weui-cells weui-cells_checkbox">
      <label
        class="weui-cell weui-cell_active weui-check__label"
        v-for="(item, index) in localItems"
        :key="index"
      >
        <div class="weui-cell__hd">
          <input
            type="checkbox"
            class="weui-check"
            v-model="item.checked"
            @change="onSelect"
          />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd">
          <p>{{ item.label || item }}</p>
        </div>
      </label>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "请选择",
    },
    value: {
      type: Array,
      default: () => [],
    },
    // 从父组件传入的选项数组
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localItems: [], // 本地副本，避免直接修改props
    };
  },
  computed: {
    display() {
      // 显示选中的项目名称，用逗号分隔
      const selectedItems = this.localItems.filter(item => item.checked);
      if (selectedItems.length === 0) {
        return "请选择";
      } else if (selectedItems.length === 1) {
        return selectedItems[0].label || selectedItems[0].value || selectedItems[0];
      } else {
        
        return selectedItems.map(item => item.label || item.value || item).join(',');
      }
    },
  },
  watch: {
    // 监听传入的items变化，更新本地副本
    items: {
      handler(newItems) {
        this.initLocalItems(newItems);
      },
      immediate: true,
    },
    // 监听传入的value变化，更新选中状态
    value: {
      handler(newVal) {
        this.updateCheckedStatus(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    // 初始化本地选项数组
    initLocalItems(items) {
      this.localItems = items.map(item => {
        if (typeof item === 'object') {
          return {
            ...item,
            checked: item.checked || false,
          };
        } else {
          return {
            label: item,
            value: item,
            checked: false,
          };
        }
      });
    },
    
    // 根据传入的value更新选中状态
    updateCheckedStatus(selectedValues) {
      if (!selectedValues || !Array.isArray(selectedValues)) return;
      
      this.localItems.forEach(item => {
        if (typeof item === 'object') {
          item.checked = selectedValues.some(val => 
            val === item.value || val === item.label || val === item
          );
        } else {
          item.checked = selectedValues.includes(item);
        }
      });
    },
    
    // 选择变化时触发
    onSelect() {
      const selectedItems = this.localItems.filter(item => item.checked);
      const selectedValues = selectedItems.map(item => {
        if (typeof item === 'object') {
          return item.value !== undefined ? item.value : item.label;
        } else {
          return item;
        }
      });
      
      // 发送选中的值数组
      this.$emit("input", selectedValues);
      this.$emit("select", selectedValues);
    },
  },
};
</script>